//// https://api.jquery.com/jquery.extend/#jQuery-extend-deep-target-object1-objectN
(function () {
    'use strict';
    jQuery.extend(true, e4.settings, {
        ecom: {
            productListWithFacets: {
                showParamsInUrl: (function () {
                    return (jQuery('.js-bionordika-order-productlist').length > 0);
                }())
            },
            orders: {
                url: '/system/data/orders'
            },
            quickorder: {
                url: '/system/data/product-list'
            },
            favorites: {
                search: {
                    url: '/system/data/favorit-list'
                }
            }
        },
        require: {
            owlcarousel: {
                url: '//cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.3.4/owl.carousel.min.js',
                fallback: '/Files/Templates/Designs/bionordika/_assets/js/vendor/owl.carousel.min.js',
                callback: null
            },
            datepicker: {
                url: '//cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.9.0/js/bootstrap-datepicker.min.js',
                fallback: '/Files/Templates/Designs/bionordika/_assets/js/vendor/bootstrap-datepicker.js',
                callback: function () {
                    e4.settings.require.datepickerLanguage.lang = e4.settings.lang;
                    e4.settings.require.datepickerLanguage.url = e4.settings.require.datepickerLanguage.url.replace('{lang}', e4.settings.require.datepickerLanguage.lang);
                    e4.settings.require.datepickerLanguage.fallback = e4.settings.require.datepickerLanguage.fallback.replace('{lang}', e4.settings.require.datepickerLanguage.lang);
                }
            },
            datepickerLanguage: {
                url: '//cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.9.0/locales/bootstrap-datepicker.{lang}.min.js',
                fallback: '/Files/Templates/Designs/bionordika/_assets/js/vendor/bootstrap-datepicker.{lang}.min.js',
                callback: null
            }
        },
        search: {
            result: {
                pages: {
                    show: jQuery( 'html' ).data( 'search-content') === true,
                    url: '/system/data/pages?q='
                },
                products: {
                    show: jQuery( 'html' ).data( 'search-ecommerce') === true,
                    url: '/system/data/product-search?q=',
                    showAllLink: '/shop/search?q=',
                    max: 4
                }
            },
            inputMinLength: 3
        }
    });
}());